module.exports = __webpack_public_path__ + "img/check-in.980c2c98.jpg";